import { render, staticRenderFns } from "./DocumentPriceChangeCRUD.vue?vue&type=template&id=3dec7bde&scoped=true"
import script from "./DocumentPriceChangeCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentPriceChangeCRUD.vue?vue&type=script&lang=js"
import style0 from "./DocumentPriceChangeCRUD.vue?vue&type=style&index=0&id=3dec7bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec7bde",
  null
  
)

export default component.exports